import RadioMui, { RadioProps } from '@mui/material/Radio';

export function Radio(props: RadioProps) {
    return <RadioMui data-testid={'Radio-container'} {...props} />;
}

export default Radio;
